const langtrans={
      fhssyy:["返回上一页","Back"],
      xgbjjj:["修改报价","Modify quotation"],
      fajbjj:["方案及报价详情","plan and  quotation details"],
      jyfa:["救援方案","Operation plan"],
      tjfj:["添加附件","Attach files"],
      ryyjyf:["如有救援方案附件","Please upload files of operation plan "],
      qsscz:["请上传","if any"],
      sc:["删除","Delete"],
      txxbjj:["填写报价","Quotation"],
      jyfy:["救援费用","Operation fee"],
      ylfy:["医疗费用","Medical cost"],
      ajfy:["案件费用","Case fee"],
      ztbtbj:["整体报价","Total"],
      wmxe:["无限额","unlimited"],
      xe:["限额","limited"],
      ssym:["说明：","Description："],
      wm:["无","None"],
      tjhf:["添加回复","Add a reply"],
      qdxgbj:["确定修改报价及方案","Confirm modification of quotation and plan"],
      qxxg:["取消修改","Cancel modifications"],
      qrhf:["确认回复","Confirm reply"],
      sfpqrt:["是否确认提交","Are you sure you want to submit?"],
      xgyx:["修改一下","Modify"],
      q:["确","Con"],
      d:["定","firm"],
      ssczfa:["上传方案及报价","Annex name upload solution and quotation"],
      fjmccc:["附件名称","Annex name"],
      fjddz:["附件地址","Annex location"],
      qd:["确定","Confirm"],
      rmb:["人民币","Ren Min Bi"],
      my:["美元","U.S. Dollar"],
      oy:["欧元","Euro"],
      ry:["日元","Japanese Yen"],
      xttb:["新台币","New Taiwan Currency"],
      qssczf:["请上传附件","Please upload the annex"],
      qsrsss:["请输入数字，而非其他","Please enter numbers only"],
      qtxxbj:["请添写报价","Please fill in the quotation"],
      xgcg:["修改成功","The modification is successful"],
      qqrsrd:["请确认输入的数值，总价必须是其他三项之和","en_translated"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/components/fac/js/alter.vue.trans.js